import { Navigate, Route, Routes } from 'react-router';
import { MainLayout } from './components/layout/MainLayout';
import DashboardPage from './features/dashboard/DashboardPage';
import { OrganisationDetailsScreen } from './features/organisation/OrganisationDetailsScreen';

export const App = () => {
  return (
    <MainLayout>
      <Routes>
        <Route path="/" element={<DashboardPage />} />
        <Route path="/organisation" element={<OrganisationDetailsScreen />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </MainLayout>
  );
};
